export default () => ({
  hierarchy: '',
  name_en: '',
  name_ja: '',
});
